<!--
[原node_modules/vue-pdf/src/vuePdfNoSss.vue文件]

vue-pdf打包后会有问题(参考http://e.betheme.net/article/show-1241.html?action=onClick)，
使用patch-package修改node_module/vue-pdf后，安装yyx-component时找不到patch-package所需补丁文件且未找到解决办法，
所以只有在本地重写原vuePdfNoSss.vue文件
-->

<style src="vue-pdf/src/annotationLayer.css"></style>
<script>

import componentFactory from 'vue-pdf/src/componentFactory.js'
import PdfjsWorker from 'pdfjs-dist/build/pdf.worker.js'

let component = null

if (process.env.VUE_ENV !== 'server') {
  var pdfjsWrapper = require('vue-pdf/src/pdfjsWrapper.js').default
  var PDFJS = require('pdfjs-dist/es5/build/pdf.js')

  if (typeof window !== 'undefined' && 'Worker' in window && navigator.appVersion.indexOf('MSIE 10') === -1) {
    // var PdfjsWorker = require('worker-loader!pdfjs-dist/es5/build/pdf.worker.js');
    PDFJS.GlobalWorkerOptions.workerPort = new PdfjsWorker()
  }

  component = componentFactory(pdfjsWrapper(PDFJS))
} else {
  component = componentFactory({})
}

export default component
</script>
